// 子仓库-报表
import to from 'await-to-js';
import * as apis from "@/api/interface/report";

export default {
  namespaced: true,
  state: () => ({
    loading: {},
    shortInsureTermList: undefined, //短险监控所属期 - 列表
    shortInsureTodayList: undefined, //短险监控当日 - 列表
    seatEvaluateList: undefined, //客服评价报表 - 列表
    settleReportList: undefined, //当日口径结案报表 - 列表
    callRecordReportList: undefined, //客服通话汇总表 - 列表
    lxComplaintReportList: undefined, // 零犀投诉报表 - 列表
    complaintStatisticsJobAll: undefined, //统计报表 - 列表
    complaintSourceList: undefined, //投诉来源 - 列表
    overtimeAutoHandleList: undefined, //超时自动处理监控 - 列表
    secondJggdList: undefined, //二次监管工单 - 列表
    lineInList: undefined, //400进线报表 - 列表
    dailyWorkPeopleList: undefined, //每日工作人数 - 列表
    callInList: undefined, //来电统计 - 列表
    complaintPeopleList: undefined, //工单人群 - 列表
    complaintResultList: undefined, //工单处理结果 - 列表
    complaintDisposeStatsList: undefined, //投诉处理能力 - 列表
    detainmentTtList: undefined, //脱退报表 - 列表
    detainmentCallbackList: undefined, //回拨挽单报表 - 列表
    detainmentIncomeList: undefined, //进线挽单报表 - 列表
    detainmentZjJfList: undefined, //重疾均分挽单报表 - 列表
    complaintTargetList: undefined, //投诉指标报表 - 列表
    aMergeDeductList: undefined, //a段合并扣费 - 列表
    aRelegateDeductList: undefined, //降级扣费 - 列表
  }),
  getters: {},
  mutations: {
    update(state, payload) {
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key];
      });
    },
  },
  actions: {
    // 短险监控所属期 - 列表
    async getShortInsureTermList(ctx, payload = {}) {
      const [err, res] = await to (apis.getShortInsureTermList(payload));
      ctx.commit("update", {
        shortInsureTermList: !err && res.data ? res.data : undefined,
      });
    },
    // 短险监控所属期 - 链路选项列表
    async getLinkOptions(_, payload = {}) {
      const [, res] = await to (apis.getLinkOptions(payload));
      return res;
    },

    // 短险监控当日 - 保司选项列表
    async getCompanyOptions(_, payload = {}) {
      const [, res] = await to (apis.getCompanyOptions(payload));
      return res;
    },
    // 短险监控当日 - 产品选项列表
    async getProductCodeOptions(_, payload = {}) {
      const [, res] = await to (apis.getProductCodeOptions(payload));
      return res;
    },
    // 短险监控当日 - 经纪公司选项列表
    async getBrokerCompanyOptions(_, payload = {}) {
      const [, res] = await to (apis.getBrokerCompanyOptions(payload));
      return res;
    },
    // 短险监控当日 - 收银台选项列表
    async getPayWayOptions(_, payload = {}) {
      const [, res] = await to (apis.getPayWayOptions(payload));
      return res;
    },
    // 短险监控当日 - 列表
    async getShortInsureTodayList(ctx, payload = {}) {
      const [err, res] = await to (apis.getShortInsureTodayList(payload));
      ctx.commit("update", {
        shortInsureTodayList: !err && res.data ? res.data : undefined,
      });
    },
    // 坐席姓名 - 选项
    async getAgentIdOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getAgentIdOptions(payload));
      return res
    },
    // 客服评价报表 - 列表
    async getSeatEvaluateList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSeatEvaluateList(payload));
      ctx.commit("update", {
          seatEvaluateList: !err && res.data ? res.data : undefined,
      });
      return res
    },
    // 零犀投诉报表 - 列表
    async getLxComplaintReportList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLxComplaintReportList(payload));
      ctx.commit("update", {
        lxComplaintReportList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 客服通话汇总表 - 列表
    async getCallRecordReportList(ctx, payload = {}) {
      const [err, res] = await to (apis.getCallRecordReportList(payload));
      ctx.commit("update", {
        callRecordReportList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 当日口径结案报表 - 列表
    async getSettleReportList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSettleReportList(payload));
      ctx.commit("update", {
        settleReportList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
      // 统计报表 - 列表
    async getComplaintStatisticsJobAll(ctx, payload = {}) {
      const [err, res] = await to (apis.getComplaintStatisticsJobAll(payload));
      ctx.commit("update", {
        complaintStatisticsJobAll: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 投诉来源 - 列表
    async getComplaintSourceList(ctx, payload = {}) {
      const [err, res] = await to (apis.getComplaintSourceList(payload));
      ctx.commit("update", {
        complaintSourceList: !err && res.data ? res.data : undefined,
      });
    },
    // 超时自动处理监控 - 列表
    async getOvertimeAutoHandleList(ctx, payload = {}) {
      const [err, res] = await to (apis.getOvertimeAutoHandleList(payload));
      ctx.commit("update", {
          overtimeAutoHandleList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 400进线报表 - 列表
    async getLineInList(ctx, payload = {}) {
      const [err, res] = await to (apis.getLineInList(payload));
      ctx.commit("update", {
        lineInList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 来电统计 - 列表
    async getCallInList(ctx, payload = {}) {
      const [err, res] = await to (apis.getCallInList(payload));
      ctx.commit("update", {
        callInList: !err && res.data ? res.data : undefined,
      });
    },
    // 每日工作人数 - 列表
    async getDailyWorkPeopleList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDailyWorkPeopleList(payload));
      ctx.commit("update", {
        dailyWorkPeopleList: !err && res.data ? res.data : undefined,
      });
    },
    // 工单人群 - 列表
    async getComplaintPeopleList(ctx, payload = {}) {
      const [err, res] = await to (apis.getComplaintPeopleList(payload));
      ctx.commit("update", {
        complaintPeopleList: !err && res.data ? res.data : undefined,
      });
    },
    // 工单处理结果 - 列表
    async getComplaintResultList(ctx, payload = {}) {
      const [err, res] = await to (apis.getComplaintResultList(payload));
      ctx.commit("update", {
        complaintResultList: !err && res.data ? res.data : undefined,
      });
    },
    // 投诉指标报表 - 列表
    async getComplaintTargetList(ctx, payload = {}) {
      const [err, res] = await to (apis.getComplaintTargetList(payload));
      ctx.commit("update", {
        complaintTargetList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 来源分布报表 - 列表
    async getComplaintOriginList(ctx, payload = {}) {
      const [, res] = await to (apis.getComplaintOriginList(payload));
      return res;
    },
    // 二次监管工单 - 列表
    async getSecondJggdList(ctx, payload = {}) {
      const [err, res] = await to (apis.getSecondJggdList(payload));
      ctx.commit("update", {
        secondJggdList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 客服通话数据表 - 列表
    async getKfCallList(ctx, payload = {}) {
      const [, res] = await to (apis.getKfCallList(payload));
      return res;
    },
    // 企微消息数据监控 - 列表
    async getQwReplayList(ctx, payload = {}) {
      const [, res] = await to (apis.getQwReplayList(payload));
      return res;
    },


    // 投诉处理能力 - 列表
    async getComplaintDisposeStatsList(ctx, payload = {}) {
      const [err, res] = await to (apis.getComplaintDisposeStatsList(payload));
      ctx.commit("update", {
        complaintDisposeStatsList: !err && res.data ? res.data : undefined,
      });
    },



    // 监控大盘 - 均分挽留报表
    // 获取挽单坐席选项列表
    async getJobOrderRetentionAgentOptions(_, payload = {}) {
      const [, res] = await to (apis.getJobOrderRetentionAgentOptions(payload));
      return res;
    },
    // 脱退报表 - 列表
    async getDetainmentTtList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetainmentTtList(payload));
      ctx.commit("update", {
        detainmentTtList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 脱退报表 - 下载
    async detainmentTtExport(_ctx, payload = {}) {
      const [, res] = await to(apis.detainmentTtExport(payload));
      return res;
    },
    // 回拨挽单报表 - 列表
    async getDetainmentCallbackList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetainmentCallbackList(payload));
      ctx.commit("update", {
        detainmentCallbackList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 回拨挽单报表 - 下载
    async detainmentCallbackExport(_ctx, payload = {}) {
      const [, res] = await to(apis.detainmentCallbackExport(payload));
      return res;
    },
    // 进线挽单报表 - 列表
    async getDetainmentIncomeList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetainmentIncomeList(payload));
      ctx.commit("update", {
        detainmentIncomeList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 进线挽单报表 - 下载
    async detainmentIncomeExport(_ctx, payload = {}) {
      const [, res] = await to(apis.detainmentIncomeExport(payload));
      return res;
    },
    // 重疾均分挽单报表 - 列表
    async getDetainmentZjJfList(ctx, payload = {}) {
      const [err, res] = await to (apis.getDetainmentZjJfList(payload));
      ctx.commit("update", {
        detainmentZjJfList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 重疾均分挽单报表 - 下载
    async detainmentZjJfExport(_ctx, payload = {}) {
      const [, res] = await to(apis.detainmentZjJfExport(payload));
      return res;
    },



    // 下载零犀客诉模版
    async getLxExcelDownTemplate(ctx, payload = {}) {
        const [, res] = await to(apis.getLxExcelDownTemplate(payload));
        return res;
    },
    // 上传零犀客诉数据
    async putLxExcelUpload(ctx, payload = {}) {
        const [, res] = await to(apis.putLxExcelUpload(payload));
        return res;
    },



    // a段合并扣费 - 筛选选项集合
    async getAMergeDeductFilterOptions(_ctx, payload = {}) {
      const [, res] = await to (apis.getAMergeDeductFilterOptions(payload));
      return res;
    },
    // a段合并扣费 - 列表
    async getAMergeDeductList(ctx, payload = {}) {
      const [err, res] = await to (apis.getAMergeDeductList(payload));
      ctx.commit("update", {
        aMergeDeductList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
    // 降级扣费 - 列表
    async getARelegateDeductList(ctx, payload = {}) {
      const [err, res] = await to (apis.getARelegateDeductList(payload));
      ctx.commit("update", {
        aRelegateDeductList: !err && res.data ? res.data : undefined,
      });
      return res;
    },
  },
  modules: {},
};
